// FAQ (08 System Pages "FAQ · How buying works"): the question search and the topic tabs. Without JavaScript every question shows and both controls stay hidden.

const normalise = value => String(value ?? '').toLowerCase().replace(/\s+/g, ' ').trim();

// Whether a question shows for the pressed topic ('' is every topic) and the search terms (every word must appear in the
// question or the answer). A search looks across every topic, so a refund question is found from the Pre-order tab.
export function faqMatch({ category, text }, topic, terms) {
  const words = normalise(terms).split(' ').filter(Boolean);
  if (topic && category !== topic && !words.length) return false;
  const haystack = normalise(text);
  return words.every(word => haystack.includes(word));
}

// 07 Prototype HELP has no "All" tab: the first topic is pressed when the page opens.
export const firstTopic = tabs => tabs[0]?.dataset?.nsFaqTab ?? '';

if (typeof document !== 'undefined') {
  for (const faq of document.querySelectorAll('[data-ns-faq]')) {
    const items = [...faq.querySelectorAll('.ns-faq__item')];
    const tabs = faq.querySelector('[data-ns-faq-tabs]');
    const search = faq.querySelector('[data-ns-faq-search]');
    const none = faq.querySelector('[data-ns-faq-none]');
    let topic = firstTopic([...(tabs?.querySelectorAll('[data-ns-faq-tab]') ?? [])]);
    const apply = () => {
      const terms = search?.value ?? '';
      let shown = 0;
      for (const item of items) {
        const match = faqMatch({ category: item.dataset.category, text: item.textContent }, topic, terms);
        item.hidden = !match;
        if (match) shown += 1;
        if (match && terms.trim()) item.open = true;
      }
      if (none) none.hidden = shown > 0;
    };
    if (tabs && tabs.querySelectorAll('[data-ns-faq-tab]').length > 1) {
      tabs.hidden = false;
      apply();
      tabs.addEventListener('click', event => {
        const tab = event.target.closest('[data-ns-faq-tab]');
        if (!tab) return;
        topic = tab.dataset.nsFaqTab;
        for (const other of tabs.querySelectorAll('[data-ns-faq-tab]')) other.setAttribute('aria-pressed', String(other === tab));
        apply();
      });
    }
    if (search) {
      faq.querySelector('[data-ns-faq-search-wrap]').hidden = false;
      search.addEventListener('input', apply);
    }
  }
}
